import { axiosSwagger } from "@/axios";

export const state = {
    postPoolFile: {
        loading: false,
        data: [],
        total: 0,
    },

    selectedIds: {
        data: [],
        id: []
    }
}


export const getters = {
}


export const mutations = {
    // POST POOL FILE
    loading: (state, loading) => {
        state.postPoolFile.loading = loading;
    },
    setData: (state, data) => {
        state.postPoolFile.data = modifyData( data );
    },
    setTotal: (state, total) => {
        state.postPoolFile.total = total;
    },
    add: (state, data) => {
        state.postPoolFile.data.push(data);
    },
    remove: (state, id) => {
        state.postPoolFile.data = state.postPoolFile.data.filter((el) => el.id !== id);
    },
    setSelectedMultiple: (state, data) => {
        if(state.selectedIds.id.includes(data.fileManagerId)){
            // remove ids array
            state.selectedIds.id = state.selectedIds.id.filter((fileId) => fileId !== data.fileManagerId);

            // remove data array
            state.selectedIds.data = state.selectedIds.data.filter((el) => el.fileManagerId !== data.fileManagerId);
        }
        else{
            // add ids
            state.selectedIds.id.push(data.fileManagerId);

            // add data
            state.selectedIds.data.push(data);
        }
    },
    setSingleSelectedMultiple: (state, data) => {
        // set single id 
        state.selectedIds.id = [data.fileManagerId];

        // set single data 
        state.selectedIds.data = [data];
    },
    removeSelectedMultiple: (state) => {
        // remove id 
        state.selectedIds.id = [];

        // remove data 
        state.selectedIds.data = [];
    },
    removeMultiple: (state, dataArr) => {
        state.postPoolFile.data = state.postPoolFile.data.filter(
          (el) => !dataArr?.includes(el.id)
        );
    },
    addMultiple: (state, dataArr) => {
        state.postPoolFile.data = state.postPoolFile.data.concat(...dataArr);
    }
}


export const actions = {
    // POST POOL FILE
    async readPostPoolFileByPostPoolId({ commit }, id) {
        commit("loading", true);

        return await axiosSwagger
        .get(`/api/PostPoolFile/Pool/${id}`)
        .then((response) => {
            commit("setData", response.data);
            commit("setTotal", response.data.length);
            commit("loading", false);

            return response;
        })
        .catch(() => {
            commit("loading", false);
        });
    },
    async createPostPoolFile({ commit }, data) {
        return await axiosSwagger
        .post(`/api/PostPoolFile`, data)
        .then((response) => {
            if(data?.item?.id  === null){
                data.item.id = response.data.id; // update ang id sa post pool file
            }

            commit("add", data.item);

            return response;
        });
    },
    // eslint-disable-next-line no-unused-vars
    async createMultiplePostPoolFile({ commit }, data) {
        return await axiosSwagger
        .post(`/api/PostPoolFile`, data)
        .then((response) => {
            if(data?.item?.id  === null){
                data.item.id = response.data.id; // update ang id sa post pool file
            }

            return data.item;
        });
    },
    // eslint-disable-next-line no-unused-vars
    async createBulkPostPoolFiles({ commit }, data) {
        return await axiosSwagger
        .post(`/api/PostPoolFile`, data)
        .then((response) => {
            return response;
        });
    },
    async deletePostPoolFile({ commit }, id) {
        return await axiosSwagger
        .delete(`/api/PostPoolFile/${id}`)
        .then((response) => {
            commit("remove", id);

            return response;
        });
    },
    // eslint-disable-next-line no-unused-vars
    async deleteMultiplePostPoolFile({ commit }, id) {
        return await axiosSwagger
        .delete(`/api/PostPoolFile/${id}`)
        .then((response) => {
            return response;
        });
    },
    // eslint-disable-next-line no-unused-vars
    async deleteBulkPostPoolFiles({ commit }, postPoolFileIds) {
        return await axiosSwagger
        .post(`/api/PostPoolFile/Remove`, postPoolFileIds)
        .then((response) => {
            return response;
        });
    },
}


// modify data to add origId for tracking the original id of the post pool file, since when we create a new post pool file, we set its id to null and update it after we get the response from the server, this is to prevent the issue of having multiple post pool files with the same id in the state before we get the response from the server and update the id.
const modifyData = (arrayData) => {
  if(arrayData?.length ?? false){
    arrayData.forEach(e => {
      e.fileManager.origId = e?.id || 0;
    });

    
    return arrayData
  }

  return [];
};
